import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useMsal } from "@azure/msal-react";

export const LAST_COURSE_DASHBOARD_KEY = "lastCourseDashboard";

export const useRememberCourseDashboard = () => {
  const { accounts } = useMsal();
  const { enrollmentId, courseExternalId } = useParams<{
    enrollmentId?: string;
    courseExternalId?: string;
  }>();
  const isSignedIn = accounts.length > 0;

  const rememberOpenCourseDashboard = () => {
    if (!isSignedIn || !enrollmentId || courseExternalId) return;
    sessionStorage.setItem(
      LAST_COURSE_DASHBOARD_KEY,
      `/course/${enrollmentId}/dashboard`
    );
  };
  useEffect(rememberOpenCourseDashboard, [
    isSignedIn,
    enrollmentId,
    courseExternalId,
  ]);
};
